/*NOTE - all index.js files in each page directory is the "entry point" for the
page and its styles and functionality. This index.js page will be included in
the main src/index.js file to load it into the portlet*/

import './view.js';

require("./view.less");



// WEBPACK FOOTER //
// ./src/pages/schedulePickup/index.js